import {
  FrVrfButton,
  FrVrfButtonPanel,
  FrVrfFormPanel,
  FrVrfMultipleLineInputField,
  FrVrfSingleLineDisplayField,
} from "@vrf/fr-vrf-web-components-react";
import React, { useEffect } from "react";
import { createModal } from "../../modal";
import { useInfraTicketDescriptionDialogState } from "./useInfraTicketDescriptionDialogState";
import { useGlobalNotifier } from "@vrf/fr-vrf-core-react";
import { usePageNavigation } from "../../../pages/use-page-navigation";
import { removeMilliseconds } from "../../../util/date-util";

export const InfraTicketDescriptionDialogContent = () => {
  const [dialogState, setDialogState] = useInfraTicketDescriptionDialogState();
  const { resetUserError } = useGlobalNotifier();
  const { moveToModalPage, closeModalPage } = usePageNavigation();

  const onInitialDisplayed = () => {
    moveToModalPage();
    resetUserError();
  };
  useEffect(onInitialDisplayed, []);

  const { isShow, tcktDesc } = dialogState;

  const onCloseHandle = () => {
    closeModalPage();
    setDialogState({
      isShow: false,
      tcktDesc: undefined,
    });
  };

  return (
    <>
      {isShow &&
        createModal(
          "Revision history",
          <>
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "#f4f4f4",
                padding: "10px",
              }}
            >
              <FrVrfFormPanel>
                <FrVrfSingleLineDisplayField
                  label="Update date:"
                  firstValue={removeMilliseconds(tcktDesc!.updtDateTime)}
                />
                <FrVrfMultipleLineInputField
                  style={{
                    "--vrf-multiple-line-input-field-input-height": "200px",
                    "--vrf-multiple-line-input-field-input-width": "300px",
                  }}
                  tabindex="1"
                  labelContent="Description"
                  resize="both"
                  content={tcktDesc?.tcktDesc}
                />
              </FrVrfFormPanel>
            </div>
            <div
              style={{
                position: "absolute",
                right: 0,
                bottom: 0,
              }}
            >
              <FrVrfButtonPanel>
                <FrVrfButton
                  size="large"
                  content="Close"
                  theme="primary"
                  onClick={onCloseHandle}
                />
              </FrVrfButtonPanel>
            </div>
          </>,
          onCloseHandle,
        )}
    </>
  );
};
